import m from 'mithril';

export const inferIdFromPath = () => {
  const campaignId = Number(m.route.param('id')) || undefined;

  return campaignId;
};

export const inferInitialTabIndexFromPath = () => {
  const tabName = window.location.pathname.split('/')?.[4];

  switch (tabName) {
    case 'scheduling':
      return 1;
    case 'audience':
      return 2;
    default:
      return 0;
  }
};

export const redirectToActivityList = () => {
  m.route('/activity');
};

export const applyTabChangeToRoute = (index: number) => {
  const subPath = window.location.pathname
    .split('/')
    .filter((_, i) => i <= 3)
    .join('/');

  if (index < 0 || index > 2) {
    return;
  }

  const pathTarget = {
    0: subPath,
    1: `${subPath}/scheduling`,
    2: `${subPath}/audience`,
  }[index];

  window.history.replaceState({}, '', pathTarget);
};
